import Vue from 'vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';

Vue.use(VeeValidate);
var app = new Vue({
    el: '#v_login_app',
    data: {
        errorMessage: '',
        username: '',
        password: '',
        baseUrl: baseUrl,
    },
    created() {
        this.setFocus();
    },
    methods: {
        setFocus() {
            setTimeout(() => {
                this.$refs.username.focus();
            }, 500);
        },
        async login() {

            console.log('🔥 login() clicked'); // <-- เพิ่มบรรทัดนี้


            const task = Promise.all([
                this.$validator.validate('username'),
                this.$validator.validate('password'),
            ]);
            const areValid = (await task).every(isValid => isValid);
            console.log('✅ validation result:', areValid);
            if (!areValid) {
                return;
            }
            const vm = this;
            console.log('📤 sending login request', vm.username);

            // axios.defaults.headers.common["X-CSRF-TOKEN"] = document
            //     .querySelector('meta[name="csrf-token"]')
            //     .getAttribute("content");

            var formData = new FormData();
            formData.append('username', vm.username);
            formData.append('password', vm.password);
            axios.post(`${this.baseUrl}/index/login`,
                formData
            ).then(({ data }) => {
                console.log('📥 response:', data);
                if (data) {
                    if (data.success) {
                        window.location = `${this.baseUrl}/member/home`;
                    } else if (data.message) {
                        alertbox(data.message, 'danger');
                    }
                }
            })
            .catch(err => {
                console.log('err', err.response);
                if (err.response && err.response.data && err.response.data.message) {
                    alertbox(err.response.data.message, 'danger');
                }
            });
        }

    },
});
